import { useState } from "react";
import { History, ChevronDown, ChevronUp } from "lucide-react";

export const ScoreHistory = ({ batches }) => {
  const [openId, setOpenId] = useState(null);
  if (!batches?.length) return null;

  return (
    <div className="technical-card p-6 mb-10" data-testid="portal-score-history">
      <div className="flex items-center gap-2 mb-1">
        <History size={14} className="text-sky-600" />
        <p className="text-xs font-mono font-semibold uppercase tracking-[0.2em] text-slate-900">
          Score History — Past Exam Batches
        </p>
      </div>
      <p className="text-[11px] text-muted-foreground mb-5">Every import and course exam, newest first. Click a row for individual scores.</p>
      <div className="space-y-2">
        {batches.map((b) => {
          const pct = b.tested ? Math.round((b.passing / b.tested) * 100) : 0;
          const open = openId === b.id;
          return (
            <div key={b.id} className="rounded-md border border-slate-200 bg-slate-50" data-testid={`score-batch-${b.id}`}>
              <button
                onClick={() => setOpenId(open ? null : b.id)}
                data-testid={`score-batch-toggle-${b.id}`}
                className="w-full flex flex-wrap items-center gap-x-5 gap-y-1 px-4 py-3 text-left"
              >
                <span className="text-sm font-semibold text-slate-900">{b.exam}</span>
                <span className="text-[11px] font-mono text-muted-foreground">{(b.created_at || "").slice(0, 10)}</span>
                <span className="text-[11px] font-mono text-muted-foreground">{b.tested} tested</span>
                <span className="text-[11px] font-mono text-green-700">{b.passing} passed</span>
                <span className="text-[11px] font-mono text-muted-foreground">avg {b.avg_score ?? "—"}%</span>
                <span className="ml-auto flex items-center gap-2.5">
                  <span className="hidden sm:inline-block h-1.5 w-20 bg-slate-100 rounded-full overflow-hidden">
                    <span className={`block h-full rounded-full ${pct >= 70 ? "bg-moss" : "bg-amber"}`} style={{ width: `${pct}%` }} />
                  </span>
                  {open ? <ChevronUp size={14} className="text-muted-foreground" /> : <ChevronDown size={14} className="text-muted-foreground" />}
                </span>
              </button>
              {open && (
                <div className="px-4 pb-4 pt-3 flex flex-wrap gap-1.5 border-t border-slate-100">
                  {[...b.results].sort((a, z) => z.score - a.score).map((r) => (
                    <span
                      key={r.name}
                      className={`rounded-sm border px-2 py-1 text-[10px] font-mono ${r.score <= b.pass_mark ? "border-amber/30 bg-amber/10 text-amber-700" : "border-moss/30 bg-moss/10 text-green-700"}`}
                    >
                      {r.name} · {r.score}%
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
